import axios from 'axios'

const envUrl = process.env.VUE_APP_BACKEND_URL
const isDev = process.env.NODE_ENV === 'development'
const useProxy = isDev && (!envUrl || envUrl.startsWith('/'))

const baseURL = (useProxy ? '/api' : (envUrl || 'http://localhost:8000/api')).replace(/\/+$/, '')
console.log('[HTTP] baseURL =', baseURL) // remove depois

export const http = axios.create({
  baseURL,
  headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
  timeout: 10000,
  withCredentials: false,
})
